import { FC } from 'react';
import { FlightDetails } from 'ts/flight/interfaces/FlightDetailsResponse';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import { formatPriceCurrency, getCurrency } from 'utils/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface MultiTotalDetailsProps {
  flight: FlightDetails;
  flightPair: FlightDetails;
  onContinue: () => void;
}

const MultiTotalDetails: FC<MultiTotalDetailsProps> = ({ flight, flightPair, onContinue }) => {
  const [t] = useTranslation();

  const price =
    flight.flighPrice.grossAndTaxWithMarkup.value +
    flightPair.flighPrice.grossAndTaxWithMarkup.value;
  const currency = getCurrency(flight.priceCurrency);
  const passengersCount = flight.flightPricesByPDT.reduce(
    (acc, passenger) => acc + passenger.quantity,
    0
  );

  return (
    <div className="flex-between flight-details-total mt-30 mb-20">
      <span></span>
      <div className="total-price">
        <span className="text-bold text-md mb-10 mt-10">
          <span>{t('total')}: </span>
          <span className="text-lg">{formatPriceCurrency(price, currency)}</span>
        </span>
        <span className="text-sm mb-20">
          <span>{t('flight.total_average_passenger')}: </span>
          <span className="text-st">{formatPriceCurrency(price / passengersCount, currency)}</span>
        </span>
        <Button
          className="btn btn-primary btn-lg"
          title={t('continue')}
          onClick={() => onContinue()}
        />
      </div>
    </div>
  );
};

export default withErrorBoundary(MultiTotalDetails, 'MultiTotalDetails');
